module.exports = __webpack_public_path__ + "static/img/rule.0b86c5c8.png";